<template>
  <div :class="{'split-alerts-container': alertSources.length > 1}">
    <component v-for="(alertSource, idx) in alertSources" :key="idx" :is="alertSource" :numOfAlertSources="alertSources.length" class="center"></component>
  </div>
</template>

<script>
import ElopementAlerts from './ElopementAlerts.vue'
import MaskAlerts from './MaskAlerts.vue'
import { AlertsSource } from '@/libraries/permissions/domainPreferences'
import ObjectAlerts from '@/components/alerts/ObjectAlerts'
export default {
  name: 'SplitAlerts',
  props: {
    alertsSources: Array,
  },
  data () {
    return {
      alertSourcesComponents: {
        [AlertsSource.FACES]: ElopementAlerts,
        [AlertsSource.OBJECTS]: ObjectAlerts,
        [AlertsSource.MASKS]: MaskAlerts,
      },
    }
  },
  computed: {
    alertSources () {
      return this.alertsSources.map(alertSource => (this.alertSourcesComponents[alertSource]))
    },
  },
}
</script>

<style scoped>
.split-alerts-container {
  background: red;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
@media only screen and (min-width: 1279px) {
  .split-alerts-container {
    background: red;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
